<template>
  <div class="dealInfo-container">
    <!-- 处理记录 -->
    <!-- <div class="hearder-title"> -->
      <!-- <div class="flex_between"> -->
        <!-- <img class="title-icon" src="@/assets/img/title-icon.svg" alt="dark" /> -->
        <!-- {{ $t("zlfk.cljl") }} -->
      <!-- </div> -->
    <!-- </div> -->
    <div class="record-box">
      <div v-for="(item, index) in recordList" :key="index">
        <div>
          <div class="record-container1">
            <div class="point"></div>
            <div class="operate">
              {{item.pointName}}
            </div>
          </div>
          <div class="record-container2">
            <div class="line"></div>
            <div class="container">
              <p><span>{{ $t("climant.czry") }}：</span><span>{{ item.auditName }}</span></p>
              <p><span>{{ $t("climant.czsj") }}：</span><span>{{ item.createTime }}</span></p>
              <p><span>{{ $t("climant.czjg") }}：</span><span :style="getFontColor(item)">{{ getOperateResult(item) }}</span></p>
              <p v-if="item.auditResult == 1"><span>{{ $t("zlfk.bhyy") }}：</span><span>{{item.auditText}}</span></p>
              <p v-if="item.provisionalMeasures != undefined"><span>{{ $t("zlfk.temporary") }}：</span><span class="lineTheme" @click="viewDetailClick(item)">{{$t("operate.view")}}</span></p>
            </div>
            <!-- <div
              @click="openDetail(item)"
              class="detail"
              v-if="
                item.userTaskId !== 'Activity_0ss6860' && item.auditResult !== 2
              "
            >
              {{ $t("zlfk.lookxq") }}
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('zlfk.clxq')" :visible.sync="dialogDetail">
      <el-form :model="detail">
        <el-form-item :label="$t('climant.czry') + ':'">
          {{ detail.auditName }}
        </el-form-item>
        <el-form-item :label="$t('climant.czsj') + ':'">
          {{ detail.createTime }}
        </el-form-item>
        <el-form-item :label="$t('climant.czjg') + ':'">
          {{ getOperateResult(detail) }}
        </el-form-item>
        <el-form-item :label="$t('message.reason') + ':'">
          {{
            $i18n.locale === "zh"
              ? detail.auditText
              : detail[
                  "auditText" +
                    $i18n.locale.charAt(0).toUpperCase() +
                    $i18n.locale.slice(1)
                ]
          }}
        </el-form-item>
        <el-form-item :label="$t('zlfk.fj') + ':'">
          <upload-file
            :disabled="true"
            action="/manage/car/feedback/question/upload/file?fileType=23"
            v-model="detail.auditFileList"
          >
          </upload-file>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog width="600px" :visible.sync="measureFormDialog">
      <div slot="title" class="header-title">
        <img src="@/assets/image/interimMeasure.png" alt="" />
        <span>{{ $t("zlfk.temporary") }}</span>
      </div>
      <div class="measureDetail">
        <p>{{ measureContent }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadFile from "@/components/uploadNew.vue";
export default {
  props: {
    recordList: {
      type: Object,
      default: () => {},
    },
  },
  components: { UploadFile },
  data() {
    return {
      detail: {},
      dialogDetail: false,
      taskIdData: {
        Activity_0ss6860: { recordName: "zlfk.tjfk" },
        Activity_00011zf: { recordName: "zlfk.sp2" },
        Activity_1m3u00z: { recordName: "zlfk.cssp" },
        Activity_0627lvf: { recordName: "zlfk.csqr" },
        Activity_1kbk3hf: { recordName: "zlfk.csyz" },
      }, // 节点数据
      measureFormDialog: false,
      measureContent:"",
    };
  },
  async created() {
  },
  methods: {
    openDetail(val) {
      this.dialogDetail = true;
      this.detail = val;
    },
    // 获取操作结果
    getOperateResult({ auditResult }) {
      // 0 通过 1驳回 其他
      return auditResult === 0 ? this.$t("zlfk.tg") : auditResult === 1 ? this.$t("message.bh") : this.$t("seek.other");
    },
    // 获取操作结果
    getFontColor({ auditResult }) {
      return auditResult === 0 ? 'color:rgb(0, 136, 0)' : auditResult === 1 ? 'color:rgb(243,72,72)' : '';
    },
    viewDetailClick(item) {
      this.measureFormDialog = true;
      this.measureContent = item.provisionalMeasures;
    }
  },
};
</script>

<style lang="scss" scoped>
.dealInfo-container {
  padding-bottom: 20px;
  // .hearder-title {
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  //   font-size: 14px;
  //   color: #333333;
  //   padding: 14px 10px 14px 20px;
  //   border-bottom: 1px solid #dcdee0;
  //   .title-icon {
  //     margin-right: 10px;
  //   }
  //   p {
  //     font-size: 16px;
  //     color: #bd3124;
  //     font-weight: bold;
  //     i {
  //       font-size: 18px;
  //       color: #bd3124;
  //       display: inline-block;
  //       margin-right: 5px;
  //     }
  //   }
  // }
  .record-box {
    // padding-left: 68px;
    // margin-top: 34px;
    .record-container1 {
      display: flex;
      align-items: center;
      .point {
        width: 7px;
        height: 7px;
        border-radius: 7px;
        border: 4px solid #bd3124;
        margin-right: 13px;
      }
      .operate {
        color: #333333;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .record-container2 {
      display: flex;
      height: fit-content;
      margin: 7px 0 12px 0;
      font-size: 14px;
      .line {
        width: 1px;
        border-left: 1px dashed #bbbbbb;
        margin: 0 20px 0 7px;
      }
      .container {
        padding: 10px;
        background-color: #eeeeee;
        width: 620px;
        border-radius: 4px;
        line-height: 35px;
        color: #333333;
      }
      .container > p > span:first-child {
        white-space: nowrap;
      }
      .container > p > span:last-child {
        white-space: normal;
        word-break: break-word;
      }
      .detail {
        color: #409eff;
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }
}
</style>
